import { APITypesV1 } from "@cur8/api-client";
import { isDermaFollowUp } from "lib/isDermaFollowUp";
import { paths } from "render/routes/paths";

// Where a visit continues after room assignment, based on which exams it
// needs. Shared between AssignToRoom (fresh handover) and SelectActiveVisit
// (resuming an Ongoing visit that's already past room assignment).
export function getScanFlowUrl({
  patientId,
  visitId,
  medicalExams,
}: {
  patientId: string;
  visitId: string;
  medicalExams: APITypesV1.MedicalExam[] | undefined;
}): string {
  const isBodyScan = medicalExams?.includes(
    APITypesV1.MedicalExam.NekoBodyScan
  );
  const isEcgFollowUp = medicalExams?.includes(
    APITypesV1.MedicalExam.TwelveLeadECG
  );

  return isBodyScan
    ? paths.assignToSkinScanner.url({ patientId, visitId })
    : isEcgFollowUp
      ? paths.followUpEcg.url({ patientId, visitId })
      : isDermaFollowUp(medicalExams)
        ? paths.followUpDerma.url({ patientId, visitId })
        : paths.checkOut.url({ patientId, visitId });
}
